<template>
  <section class="video-section">
    <div class="container">
      <div class="video-header">
        <!-- 第一个标题 (如：品牌标语/小标题) -->
        <p class="section-title-sub scroll-animate fade-up" data-delay="0">
          {{ $i18n.t('video.title') }}
        </p>
        <!-- 第二个标题 (如：核心大标题) -->
        <h2 class="section-title-main scroll-animate fade-up" data-delay="100">
          {{ $i18n.t('video.title1') }}
        </h2>
        <!-- 第三个标题 (如：补充说明标题) -->
        <h3 class="section-title-tag scroll-animate fade-up" data-delay="150">
          {{ $i18n.t('video.title2') }}
        </h3>
      </div>

      <!-- 视频播放器 -->
      <div class="video-wrapper scroll-animate fade-up" data-delay="200">
        <video
          controls
          playsinline
          poster="/images/video-poster.jpg"
        >
          <source src="@/assets/video/Quantitative.mp4" type="video/mp4" />
          {{ $i18n.t('video.notSupported') }}
        </video>
      </div>

      <!-- 底部备注文字 -->
      <p class="section-desc-note scroll-animate fade-up" data-delay="300">
         {{ $i18n.t('video.description') }}
      </p>
    </div>
  </section>
</template>

<script setup>
import { useScrollAnimation } from '../composables/useScrollAnimation'
useScrollAnimation()
</script>

<style scoped>
.video-section {
  background-color: #0d1b2a;
  padding: 6.25rem 0;
  position: relative;
}

.video-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201, 169, 110, 0.3), transparent);
}

.container {
  max-width: 85rem;
  margin: 0 auto;
  padding: 0 2.5rem;
}

.video-header {
  text-align: center;
  margin-bottom: 3.125rem;
}

/* 标题 1: 顶部金色前缀标题 (调大至 1.25rem) */
.section-title-sub {
  font-size: 1.25rem;
  color: #c9a96e;
  text-transform: uppercase;
  letter-spacing: 0.15rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

/* 标题 2: 核心主标题 (调大至 2.75rem) */
.section-title-main {
  font-size: 2.75rem;
  color: #ffffff;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 0.875rem;
}

/* 标题 3: 底部辅助标题 (调大至 1.5rem) */
.section-title-tag {
  font-size: 1.5rem;
  color: #94a3b8;
  font-weight: 400;
  margin-bottom: 0;
}

.video-wrapper {
  max-width: 68rem;
  width: 100%;
  aspect-ratio: 16 / 9;
  margin: 0 auto;
  border-radius: 0.75rem;
  overflow: hidden;
  background: #000;
  border: 1px solid rgba(201, 169, 110, 0.2);
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-wrapper video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* 底部备注 (调大至 1rem，清晰可读) */
.section-desc-note {
  font-size: 1rem;
  color: #94a3b8;
  max-width: 68rem;
  margin: 1.25rem auto 0 auto;
  text-align: right;
  line-height: 1.6;
}

@media (max-width: 48rem) {
  .video-section {
    padding: 3.75rem 0;
  }

  .container {
    padding: 0 1.25rem;
  }

  .video-header {
    margin-bottom: 2rem;
  }

  .section-title-sub {
    font-size: 1rem;
  }

  .section-title-main {
    font-size: 2rem;
  }

  .section-title-tag {
    font-size: 1.2rem;
  }

  .section-desc-note {
    font-size: 0.875rem;
    text-align: center;
  }
}
</style>